import { HttpError, sendAuthedChatRequest } from './httpClient.js'

const JSON_OBJECT_DELIMITER = 'jsonobjectdelimiter'

export const requestClaude = async ({
  messages,
  attachments,
  aiVersion,
  tools,
  streamText = false,
  returnReader = false,
  signal,
  usageContext
}) => {
  if (!messages || messages.length === 0) {
    throw new Error('Cannot make AI call with empty messages.')
  }

  const CHAT_API_URL = process.env.VUE_APP_CHAT_API_URL

  const requestBody = {
    aiVersion,
    messages,
    attachments,
    tools,
    streamText,
    usageContext
  }

  try {
    const response = await sendAuthedChatRequest(CHAT_API_URL, requestBody, signal)

    let rawText
    if (!streamText && !returnReader) {
      rawText = await response.text()
    }

    if (!streamText && !returnReader && !rawText?.includes(JSON_OBJECT_DELIMITER)) {
      const response = JSON.parse(rawText)
      if (response?.error?.message) {
        throw new Error(response.error.message)
      }
    }

    if (returnReader) {
      if (!response.body) {
        throw new Error('Response body is null, cannot return reader.')
      }

      return response.body.getReader()
    }

    if (rawText.trim() === '') {
      return null
    }
    const parts = rawText.split(JSON_OBJECT_DELIMITER).filter((part) => part.trim() !== '')
    if (parts.length === 0) {
      return null
    }
    const parsedResponse = JSON.parse(parts[0])
    if (parsedResponse?.message && parsedResponse.message.includes('Failed to parse AI response')) {
      throw new Error(parsedResponse.message)
    }

    return parsedResponse
  } catch (error) {
    if (error.name === 'AbortError') {
      throw error
    }

    if (error instanceof HttpError) {
      throw new Error(`AI Lambda service call failed: ${error.message}. Server detail: ${error.body || 'N/A'}`)
    }

    throw new Error(`AI Lambda service call failed: ${error.message}`)
  }
}
